import { createContext, useContext, useEffect, useState } from 'react'
import { onAuth, subscribe, OWNER_EMAIL, logOut } from './lib/firebase.js'
import { configureFormat } from './lib/format.js'
import { DEFAULT_SETTINGS } from './lib/constants.js'

const Ctx = createContext(null)

export function DataProvider({ children }) {
  const [user, setUser] = useState(undefined)
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => onAuth(async (u) => {
    if (u && OWNER_EMAIL && u.email?.toLowerCase() !== OWNER_EMAIL) {
      setError(`${u.email} is not allowed to use this app.`)
      await logOut()
      return
    }
    setUser(u)
  }), [])

  useEffect(() => {
    if (!user) { setData(null); return }
    return subscribe(
      (d) => {
        const settings = { ...DEFAULT_SETTINGS, ...d.settings }
        configureFormat(settings)
        setData({ ...d, settings })
      },
      (e) => setError(e.message),
    )
  }, [user])

  return <Ctx.Provider value={{ user, data, error, setError }}>{children}</Ctx.Provider>
}

export const useStore = () => useContext(Ctx)
export const useData = () => useContext(Ctx).data
